module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      "sideBar": true, "fade-in": _vm.showToggleButton
    },
    attrs: {
      "id": "pendingSidebar"
    },
    on: {
      "mouseenter": _vm.openSideBar
    }
  }, [_c('i', {
    staticClass: "fa fa-bars primary-green-text left"
  })]), _vm._v(" "), _c('side-bar', {
    attrs: {
      "show": _vm.sideBarToggle,
      "fetchAggregatedOffer": _vm.fetchAggregatedOffer,
      "submitButtonPresent": true,
      "type": _vm.popUptype,
      "sidebarHeader": _vm.sideBarTitle
    },
    on: {
      "sidebarInactive": _vm.closeSideBar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "outer-div-min",
    attrs: {
      "id": "outerDivMinId"
    }
  }, [_c('div', {
    staticClass: "inner-div text-center",
    attrs: {
      "id": "selectedOffersInnerDiv"
    }
  }, [(this.fixedTableData.length > 0) ? _c('div', [_c('div', {
    staticStyle: {
      "table-layout": "fixed",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.fixedTableData), function(row) {
    return _c('tr', _vm._l((row), function(column, i) {
      return _c('td', {
        class: {
          'primary-green-text': column.data.others && column.data.others.clickable, 'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
        },
        on: {
          "click": function($event) {
            _vm.childEvent(column.data)
          }
        }
      }, [_vm._v(_vm._s(column.data.value) + "\n              ")])
    }))
  })], 2)]), _vm._v(" "), _c('div', {
    class: {
      'table-two-parent': true, 'beforeCollpaseHeight': !_vm.getterNavBarCollapse, 'afterCollapseHeight': _vm.getterNavBarCollapse
    }
  }, [_c('table', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, _vm._l((_vm.scrollableTableData), function(row) {
    return _c('tr', _vm._l((row), function(column, i) {
      return _c('td', {
        class: {
          'left-align': i === 0, 'fix-header-width': i === 0, 'cell-data-width': i !== 0
        }
      }, [_vm._l((_vm.getCellRecord(column.data.value)), function(value) {
        return [_c('span', {
          class: {
            'red-text': value.length > 1 && (/^[-][^a-zA-Z]+$/g.test(value)), 'margin-right': value === '(', 'margin-left': value === ')'
          }
        }, [_vm._v("\n                    " + _vm._s(value) + "\n                  ")])]
      })], 2)
    }))
  }))])]) : _c('div', {
    staticClass: "preview"
  }, [_c('h2', {
    staticClass: "grey-text"
  }, [_vm._v(_vm._s(_vm.defaultNote))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    style: ({
      'margin-top': '1rem'
    })
  }, [_c('button', {
    class: {
      'width_3': true, 'primary-green-bg': true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadPortalGuide
    }
  }, [_vm._v("\n          Download Portal Guide\n        ")]), _vm._v(" "), _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadManufacturerInfo
    }
  }, [_vm._v("\n          Download Manufacturer Info\n        ")]), _vm._v(" "), _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadNegativeMarginItems
    }
  }, [_vm._v("\n          DOWNLOAD NEGATIVE MARGIN ITEMS\n        ")]), _vm._v(" "), _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': !_vm.buttonDisabled
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonDisabled
    },
    on: {
      "click": _vm.downloadAllDetails
    }
  }, [_vm._v("\n          Download Selected Period Data\n        ")]), _vm._v(" "), (_vm.isLoginSuperUser) ? _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': !_vm.buttonDisabled
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isLoginSuperUser || _vm.buttonDisabled
    },
    on: {
      "click": function($event) {
        _vm.sendMail()
      }
    }
  }, [_vm._v("\n          Send Final Confirmation Mail\n        ")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("CLASSIFIED BY TOOL")]), _vm._v(" "), _c('th', [_vm._v("GREEN")]), _vm._v(" "), _c('th', [_vm._v("YELLOW")]), _vm._v(" "), _c('th', [_vm._v("RED")]), _vm._v(" "), _c('th', [_vm._v("TOTAL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-770b927c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pending-approval/PendingApproval.vue
// module id = 375
// module chunks = 2